import type { IDirective } from "angular";
import { module } from "angular";
import "./UniqueValidationDirective";

import { InputDirectiveFunctions } from "App/Modules/Gui/Directives";

export default class InputUniqueDirective implements IDirective {
    public priority = 1000;

    public restrict = "E";

    public scope = {
        irLabel: "<",
        ngModel: "=",
        uniqueGroupName: "@",
    };

    public link = InputDirectiveFunctions.link; // eslint-disable-line @typescript-eslint/unbound-method

    public compile = InputDirectiveFunctions.compile(this.link);

    public template: string;

    constructor() {
        this.template = `<input type="text" aa-field-group="ngModel" aa-label="{{irLabel | translate}}" ir-unique>`; // eslint-disable-line
    }
}

module("mmGui").directive("irInputUnique", () => new InputUniqueDirective());
